/**
 * Wallet Pass Service
 * Issues and serves Apple Wallet and Google Wallet loyalty passes for Convercus programs. Internal administrators register programs, mint program API keys, maintain store locations, configure wallet design and levels, read adoption analytics and query the audit trail; customer-facing clients download a pass through the program-scoped download routes, and the wallets themselves keep it current through the Apple PassKit web service and the Google Wallet Objects callback. Every path below already carries the gateway base prefix `/wallet-pass-service`.
 *
 * The version of the OpenAPI document: 1.0.39938
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppleWalletCtaInputDto { 
    /**
     * Not rendered by Apple, which builds the button title from `type`. Stored as-is so the entry reads like a Google one; trimmed, at most 40 characters. Omitting it does not hide the action.
     */
    label?: string;
    /**
     * HTTPS URL only. Opened when the user taps the action.
     */
    url: string;
    /**
     * Semantic intent of the featured action. Apple renders the localized button title and icon from this value, so it cannot be free text. Omit to fall back to a loyalty default by list index (`membershipBenefits`, then `viewOffersRewards`). Duplicate effective types (including fallbacks) are rejected.
     */
    type?: AppleWalletCtaInputDto.TypeEnum;
    /**
     * When true the action is stored but not shown on Apple Wallet. Omit or false to show it.
     */
    hidden?: boolean;
}
export namespace AppleWalletCtaInputDto {
    export type TypeEnum = 'viewSchedule' | 'watchTrailer' | 'listenToMusic' | 'call' | 'place' | 'addToBalance' | 'order' | 'shop' | 'membershipBenefits' | 'bookAppointment' | 'bookCar' | 'bookFlight' | 'bookStay' | 'viewOffersRewards';
    export const TypeEnum = {
        ViewSchedule: 'viewSchedule' as TypeEnum,
        WatchTrailer: 'watchTrailer' as TypeEnum,
        ListenToMusic: 'listenToMusic' as TypeEnum,
        Call: 'call' as TypeEnum,
        Place: 'place' as TypeEnum,
        AddToBalance: 'addToBalance' as TypeEnum,
        Order: 'order' as TypeEnum,
        Shop: 'shop' as TypeEnum,
        MembershipBenefits: 'membershipBenefits' as TypeEnum,
        BookAppointment: 'bookAppointment' as TypeEnum,
        BookCar: 'bookCar' as TypeEnum,
        BookFlight: 'bookFlight' as TypeEnum,
        BookStay: 'bookStay' as TypeEnum,
        ViewOffersRewards: 'viewOffersRewards' as TypeEnum
    };
}


